module.exports = __webpack_public_path__ + "img/volleyball.66e13ac3.svg";